import { Component, input, output } from '@angular/core';
import { TableColumn } from '@ntv360/component-pantry';
import { TableComponent } from '@shared/components/table/table.component';
import { TableToolbarButton } from '@shared/interfaces/table-toolbar.interface';

@Component({
    selector: 'app-table-panel',
    standalone: true,
    imports: [TableComponent],
    templateUrl: './table-panel.component.html',
    styleUrl: './table-panel.component.scss',
})
export class TablePanelComponent {
    /**
     * Column definitions for the licenses table.
     */
    public columns = input<TableColumn[]>([]);

    /**
     * Row data for the licenses table.
     */
    public data = input<any[]>([]);

    /**
     * Toolbar button definitions passed to the table toolbar.
     */
    public toolbarButtons = input<TableToolbarButton[]>([]);

    /**
     * Placeholder text for the toolbar search input.
     */
    public placeholder = input<string>('Search...');

    /**
     * Optional title shown in the table header.
     */
    public tableTitle = input<string>('Data Table');

    /**
     * CSS height value for the table container.
     */
    public tableHeight = input<string>('700px');

    /**
     * Whether to render the row-selection checkboxes.
     */
    public hasCheckBox = input<boolean>(false);

    /**
     * Whether the column visibility settings control is shown on the table.
     */
    public showColumnSettings = input<boolean>(true);

    /**
     * Whether the table is in a loading state.
     */
    public loading = input<boolean>(false);

    /**
     * Emitted when a toolbar action button is clicked.
     * Carries the button's action name.
     */
    public toolbarAction = output<string>();

    /**
     * Emitted when the search value changes.
     */
    public searchValueChange = output<string>();

    /**
     * Emitted when the table row selection changes.
     */
    public selectionChange = output<any[]>();

    /**
     * Emitted when a redirectable table cell is clicked.
     */
    public cellClick = output<{ field: string; value: any; row: any }>();

    /**
     * Emitted when an inline table action button is clicked.
     */
    public actionClick = output<{ action: string; row: any }>();
}
